export const PaymentFr = {
  "Paiements": "Paiements",
}